import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';

export const ModalOKCancel = (props) => (

    <Modal backdrop="static" show={props.show} >
        <Modal.Header>
            <Modal.Title style={{ textAlign: 'center' }}>{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: 'center' }}>{props.body}</Modal.Body>
        <Modal.Footer style={{ textAlign: 'center' }}>
            <button className="ogcButton btn-std-size" onClick={props.onOK} >{props.okText === undefined ? "OK" : props.okText}</button>
            <button className="ogcButton ogcButton-brown btn-std-size" onClick={props.onCancel}>Cancel</button>
        </Modal.Footer>
    </Modal>
);

export class ModalSelectGuide extends Component {
    render() {
        return (
            <Modal backdrop="static" show={this.props.show} >
                <Modal.Header>
                    <Modal.Title style={{ textAlign: 'center' }}>{this.props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ textAlign: 'center' }}>
                    {this.props.orderGuideGroupList.length > 0 &&
                        <select className="orderGuideSelect" style={{ marginRight: '10px' }} onChange={this.props.onChange} value={this.props.modalGuideGroupId} name={this.props.name}>
                            {this.props.orderGuideGroupList.map((ogg) =>
                                <option key={ogg.orderGuideGroupId} value={ogg.orderGuideGroupId}>{ogg.orderGuideGroupName.length > 30 ? `${ogg.orderGuideGroupName.substring(0, 30)}...` : ogg.orderGuideGroupName}</option>
                            )}
                        </select>
                    }
                    {this.props.orderGuideGroupList.length === 0 &&
                        <span>No published order guides to copy from.</span>
                    }
                </Modal.Body>
                <Modal.Footer style={{ textAlign: 'center' }}>
                    {this.props.orderGuideGroupList.length > 0 &&
                        <button className="ogcButton btn-std-size" onClick={(e) => { this.props.onOK(this.props.modalGuideGroupId); }} >{this.props.okText === undefined ? "OK" : this.props.okText}</button>
                    }
                    <button className="ogcButton ogcButton-brown btn-std-size" onClick={this.props.onCancel}>Cancel</button>
                </Modal.Footer>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/shared/modals.js